import React from "react";
import myImage from "../image/hero-five.jpeg";
import myPDF from "../image/Priyanshu-cv.pdf";
import { fadeIn } from "react-animations";

const About = () => {
  return (
    <>
      <section className="about_section" id="about">
        <div className="container">
          <div className="row">
            <h2 className="about_main_heading">About Us</h2>

            <div className="col-lg-6">
              <img src={myImage} className="about_img" />
            </div>
            <div className="col-lg-6">
              <div className="about-content">
                <ul>
                  <li>
                    <span>First Name </span>:Priyanshu
                  </li>
                  <li>
                    <span>Last Name</span> :Kushwaha
                  </li>
                  <li>
                    <span>Email</span> :Kushpriyanshu91@gmail.com
                  </li>
                  <li>
                    <span>Phone</span> :+91 7500058993
                  </li>
                  <li>
                    <span>Dob</span> :9 Jan 1999
                  </li>
                  <li>
                    <span>Nationality</span> :Indian
                  </li>
                  <li>
                    <span>Language</span> :Hindi
                  </li>
                  <li>
                    <span>Address </span> :New Ashok Nagar New Delhi
                  </li>
                </ul>
                <a
                  href={myPDF}
                  download="Priyanshu-cv.pdf"
                  className="header_button about_btn mt-4"
                >
                  Download Resume
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
